/* eslint-disable no-param-reassign */

/**
 * Get an objects property value by path
 * @param {string} path - Path to search for, i.e. 'object.key.anotherKey'
 * @param {object} object - Object to search in
 *
 * @return {*} - The resolved value or undefined if path does not exist in object
 */
export const getValueByPath = (path, object = {}) => {
  const keys = path.split('.');
  let index = 0;
  let value = object;
  while (value && index < keys.length) {
    value = value[keys[index]];
    index += 1;
  }
  return index === keys.length ? value : undefined;
};
